import React, { Component } from "react";
import { SnackbarProvider } from "notistack";
import { Provider } from "react-redux";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { AuthWrapper } from "./components/sharedComponents";
import App from "./containers/App"; // Main Container
import configureStore from "./redux/configureStore";
import CacheBuster from "react-cache-buster";
import packageInfo from "../package.json";
import { Loading } from "../src/components/sharedComponents";
import "bootstrap/dist/css/bootstrap.min.css";

import "./index.css";
const store = configureStore();

class Main extends Component {
  render() {
    return (
      <>
        <CacheBuster
          currentVersion={packageInfo.version}
          isEnabled={true}
          isVerboseMode={false}
          loadingComponent={<Loading />}
          metaFileDirectory={packageInfo.homepage}
        >
          <SnackbarProvider
            maxSnack={3}
            anchorOrigin={{
              vertical: "top",
              horizontal: "center"
            }}
          >
            <Provider store={store}>
              <BrowserRouter basename={process.env.REACT_APP_PATH}>
                <Switch>
                  <Route
                    path="/:mailbox/compose"
                    render={(props) => (
                      <App {...props} {...this.props} action={"Compose"} />
                    )}
                  />
                  <Route
                    path="/:mailbox/drafts"
                    render={(props) => (
                      <App {...props} {...this.props} action={"Drafts"} />
                    )}
                  />
                  <Route
                    path="/:mailbox/contactus"
                    render={(props) => (
                      <App {...props} {...this.props} action={"Contact Us"} />
                    )}
                  />
                  <Route
                    path="/:mailbox/:action/:messageId"
                    render={(props) => (
                      <App
                        {...props}
                        {...this.props}
                        action={
                          props.match.params.action.toLowerCase() === "sent"
                            ? "Sent"
                            : "Received"
                        }
                        path={
                          props.match.params.action.toLowerCase() === "sent"
                            ? "Sent"
                            : "Inbox"
                        }
                      />
                    )}
                  />
                  <Route
                    path="/:mailbox/:action"
                    render={(props) => (
                      <App
                        {...props}
                        {...this.props}
                        action={
                          props.match.params.action.toLowerCase() === "sent"
                            ? "Sent"
                            : "Received"
                        }
                        path={
                          props.match.params.action.toLowerCase() === "sent"
                            ? "Sent"
                            : "Inbox"
                        }
                      />
                    )}
                  />
                  <Route
                    path="/:action"
                    render={(props) => (
                      <App
                        {...props}
                        {...this.props}
                        action={
                          props.match.params.action.toLowerCase() === "sent"
                            ? "Sent"
                            : "Received"
                        }
                        path={
                          props.match.params.action.toLowerCase() === "sent"
                            ? "Sent"
                            : "Inbox"
                        }
                      />
                    )}
                  />
                  <Route
                    path="/"
                    render={(props) => (
                      <App {...props} {...this.props} action={"inbox"} />
                    )}
                  />
                </Switch>
              </BrowserRouter>
            </Provider>
          </SnackbarProvider>
        </CacheBuster>
      </>
    );
  }
}

export default AuthWrapper(Main);
